
<template>
  <div class="index" v-cloak>
    <!-- 头部 -->
    <Header/>
    <!-- 轮播图 -->
    <div class="carousel st_carousel">
      <el-carousel :loop="false" :autoplay="false">
        <el-carousel-item v-for="(item, index) in solutionList" :key="index">
          <div class="cs_contain" :style='{ backgroundImage : "url(" + item.url + ")" }'>
            <div class="content-width">
              <div :class="['cs_word', index === 2 ? 'cs_word_white' : '']">
                <div v-cloak v-if="item.title1" class="title1">{{item.title1}}</div>
                <div v-cloak class="title2">{{item.title2}}</div>
                <div v-cloak class="remark">{{item.remark}}</div>
              </div>
<!--              <el-button type="primary" round class="use_btn" @click="useClick">申请试用</el-button>-->
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 全链数字化解决方案 -->
    <div class="st_product">
      <div class="content content-title">
        <div class="title">全链数字化解决方案</div>
        <div class="remark" style="width: auto;">广州市智慧农业服务股份有限公司专注于打造“农田-流通-餐桌”农业产业链数字化解决方案</div>
        <img class="partner-bg" style="width: 60rem;height: 26.45rem;margin-top: 2rem;" src="@/assets/img/solution/pic/soBg.jpg" />
      </div>
    </div>

    <!-- 数字农业 -->
    <div class="carousel range">
      <div class="content content-title" style="width: 72.2rem;">
        <div class="title">数字农业</div>
        <div class="remark" style="width: 48rem;">通过部署在农业生产场所的各类型数据采集终端和智能控制设备，实现农业生产环境的智能感知预警、智能控制管理以及智能决策分析, 为农业生产提供管理种植管理，提高生产效率与效益</div>
        <el-carousel :interval="95000" arrow="always" indicator-position="none" style="height: 16.8rem;">
          <el-carousel-item v-for="(item, index) in digitalPagedList" :key="index">
            <div class="content" style="height: 16.6rem;">
              <div class="infoList">
                <div class="sonItem" v-for="(sonItem, sonIndex) in item.list" :key="sonItem.id"
                  :style='{ backgroundImage : "url(" + sonItem.picture + ")" }'>
                  <div class="info_wrap">
                    <div class="info_title ellipsis">{{sonItem.title}}</div>
                    <div class="ellipsis info_remark">{{sonItem.description}}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- 农产品流通 -->
    <div class="carousel range">
      <div class="content content-title" style="width: 72.2rem;">
        <div class="title">农产品流通</div>
        <div class="remark" style="width: 48rem;">全面优化农产品从产地到市场的流通环节，系统之间相互协作，确保农产品流通的高效性、透明度和智能化</div>
        <el-carousel :interval="95000" arrow="always" indicator-position="none" style="height: 16.8rem;">
          <el-carousel-item v-for="(item, index) in proPagedList" :key="index">
            <div class="content" style="height: 16.6rem;">
              <div class="infoList">
                <div class="sonItem" v-for="(sonItem, sonIndex) in item.list" :key="sonItem.id"
                     :style='{ backgroundImage : "url(" + sonItem.picture + ")" }'>
                  <div style="width: 18.95rem;"></div>
                  <div class="info_wrap">
                    <div class="info_title ellipsis">{{sonItem.title}}</div>
                    <div class="ellipsis info_remark">{{sonItem.description}}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- 智慧后勤 -->
    <div class="carousel range">
      <div class="content content-title" style="width: 72.2rem;">
        <div class="title">智慧后勤</div>
        <div class="remark" style="width: 48rem;">AI算法深度结合智能终端设备，联动后台管理系统，优化食品安全监管与食堂经营管理，引领后勤智能化革新浪潮</div>
        <el-carousel :interval="95000" arrow="always" indicator-position="none" style="height: 16.8rem;">
          <el-carousel-item v-for="(item, index) in logisticsPagedList" :key="index">
            <div class="content" style="height: 16.6rem;">
              <div class="infoList">
                <div class="sonItem" v-for="(sonItem, sonIndex) in item.list" :key="sonItem.id"
                     :style='{ backgroundImage : "url(" + sonItem.picture + ")" }'>
                  <div style="width: 18.95rem;"></div>
                  <div class="info_wrap">
                    <div class="info_title ellipsis">{{sonItem.title}}</div>
                    <div class="ellipsis info_remark">{{sonItem.description}}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- 农产品监测全链条 -->
    <div class="carousel range">
      <div class="content content-title" style="width: 72.2rem;">
        <div class="title">农产品监测全链条</div>
        <div class="remark" style="width: 48rem;">以全产业链质量咨询为先导，提供食品安全检测、技术支持与质量管理服务，凭借国际公信力资质与深度技术积累， 筑牢“从农田到餐桌”的质量长城</div>
        <el-carousel :interval="95000" arrow="always" indicator-position="none" style="height: 16.8rem;">
          <el-carousel-item v-for="(item, index) in wholePagedList" :key="index">
            <div class="content" style="height: 16.6rem;">
              <div class="infoList">
                <div class="sonItem" v-for="(sonItem, sonIndex) in item.list" :key="sonItem.id"
                     :style='{ backgroundImage : "url(" + sonItem.picture + ")" }'>
                  <div style="width: 18.95rem;"></div>
                  <div class="info_wrap">
                    <div class="info_title ellipsis">{{sonItem.title}}</div>
                    <div class="ellipsis info_remark">{{sonItem.description}}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- 农业产业园规划运营 -->
    <div class="carousel range">
      <div class="content content-title">
        <div class="title">农业产业园规划运营</div>
        <div class="remark" style="width: 48rem;">集规模化种植、标准化生产、商品化处理、品牌化销售、产业化经营于一体，提供从规划到落地、运营的一二三产融合服务，
          推动农业产业闭环与可持续发展</div>
        <el-carousel :interval="95000" arrow="never" indicator-position="none" style="height: 16.8rem;">
          <el-carousel-item v-for="(item, index) in planList" :key="index">
            <div class="content" style="height: 16.6rem;">
              <!-- <div class="title">智慧资讯 </div>
              <div class="remark">时刻为您提供智慧农业最新资讯和产品动态</div> -->
              <div class="infoList">
                <div class="sonItem" v-for="(sonItem, sonIndex) in item.list" :key="sonIndex"
                     :style='{ backgroundImage : "url(" + sonItem.picture + ")" }'>
                  <!--                  <img v-if="sonItem.isNew" class="isNew" src="@/assets/img/institute/icon/new.svg" />-->
                  <!--                  <img class="info_img" :src="sonItem.picture || '@/assets/img/index/pic/info.jpg' " />-->
                  <div style="width: 18.95rem;"></div>
                  <div class="info_wrap">
                    <div class="info_title ellipsis">{{sonItem.title}}</div>
                    <div class="ellipsis info_remark">{{sonItem.description}}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- 食链云商学院 -->
    <div class="carousel range">
      <div class="content content-title">
        <div class="title">食链云商学院</div>
        <div class="remark" style="width: 48rem;">广州市智慧农业服务股份有限公司与食链云商学院形成战略合作关系为穗盈供应链系统的用户提供实战赋能、价值共生的商学知识服务</div>
        <el-carousel :interval="95000" arrow="never" indicator-position="none" style="height: 16.8rem;">
          <el-carousel-item v-for="(item, index) in collegeList" :key="index">
            <div class="content" style="height: 16.6rem;">
              <div class="infoList">
                <div class="sonItem" v-for="(sonItem, sonIndex) in item.list" :key="sonIndex"
                     :style='{ backgroundImage : "url(" + sonItem.picture + ")" }'>
                  <div style="width: 18.95rem;"></div>
                  <div class="info_wrap">
                    <div class="info_title ellipsis">{{sonItem.title}}</div>
                    <div class="ellipsis info_remark">{{sonItem.description}}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- 客服 -->
    <CustCare />
    <!-- 申请 -->
    <Apply ref="applyRef" />
    <!-- 页面申请 -->
    <ApplyIndex />
    <!-- 联系 -->
    <Contact />
    <!-- 尾部 -->
    <Footer />

  </div>

<!--  <div class="bdsharebuttonbox" style="display:none;">-->
<!--    <xx style="float: left; font-size: 12px;line-height:30px;"> </xx>-->
<!--    <a href="#" class="bds_weixin" data-cmd="weixin" title="分享到微信" id="wx_share"></a>-->
<!--  </div>-->
</template>
<script>
  import Header from '@/views/pc/components/header'
  import Contact from '@/views/pc/components/contact'
  import CustCare from '@/views/pc/components/custCare'
  import Footer from '@/views/pc/components/footer'
  import Apply from '@/views/pc/components/apply'
  import ApplyIndex from '@/views/pc/components/applyIndex'
  import axios from "axios";
  export default {
    name: "Solution",
    components: { Header, Contact, CustCare, Footer, Apply, ApplyIndex },
    data () {
      return {
        // 解决方案轮播图
        solutionList: [
          {
            // title1: '做生鲜配送公司',
            title2: '农业产业链解决方案',
            remark: '数字化覆盖“农田·流通·餐桌”全链条',
            url: require('@/assets/img/solution/pic/cs1.jpg')
          }
        ],
        digitalList: [
          {
            list: [
              {
                id: 1,
                title: '农业四情监测',
                description: '系统整合了土壤墒情站、虫情仪、气象站等，实现对 墒情、虫情、气候以及苗情的实时数据采集、预测以 及智能分析。',
                picture: require('@/assets/img/solution/pic/so1_1.jpg')
              },
              {
                id: 2,
                title: '水肥一体化',
                description: '核心智能施肥机实现精准配比与自动灌溉，结合灵活 的阀门控制系统，显著提升水肥利用率。',
                picture: require('@/assets/img/solution/pic/so1_2.jpg')
              },
              {
                id: 3,
                title: '大棚智能控制',
                description: '整合环境监测、自动化调控与视频监控，实现对温、\n' +
                  '光、水、气等要素的精准管理，助力作物在最适环境\n' +
                  '中生长。',
                picture: require('@/assets/img/solution/pic/so1_3.jpg')
              }
            ]
          },
          {
            list: [
              {
                id: 4,
                title: '智慧农业云平台',
                description: '集农场管理、设备远程控制与农产品溯源功能于一\n' +
                  '体，为农业经营主体的数字化管理提供强大工具。',
                picture: require('@/assets/img/solution/pic/so1_4.jpg')
              },
              {
                id: 5,
                title: '农业大数据平台',
                description: '利用大数据进行精准农业管理，为经营决策与宏观\n' +
                  '管理提供可视化分析与洞察。',
                picture: require('@/assets/img/solution/pic/so1_5.jpg')
              }
            ]
          }
        ],
        proList: [
          {
            list: [
              {
                id: 1,
                title: '穗盈生鲜供应链系统',
                description: '针对食材配送供应链各环节，为生鲜配送企业提供从\n' +
                  '订单管理、采购、库存管理到分拣配送、财务管理、\n' +
                  '经营分析的全流程覆盖。',
                picture: require('@/assets/img/solution/pic/so2_1.jpg')
              },
              {
                id: 2,
                title: '麦小菜农批SaaS系统',
                description: '专为批发市场档口经营管理而设计，提供快速开单、\n' +
                  '赊欠记账、催收还款、库存管理、经营分析等功能。',
                picture: require('@/assets/img/solution/pic/so2_2.jpg')
              },
              {
                id: 3,
                title: '真甜农服价格指数平台',
                description: '专业采集发布全国蔬菜价格的，覆盖从种子到基地、\n' +
                  '从种植到采收、从流通到销售的一站式农产品信息与\n' +
                  '技术共享平台。',
                picture: require('@/assets/img/solution/pic/so2_3.jpg')
              }
            ]
          },
          {
            list: [
              {
                id: 4,
                title: '智慧农贸市场解决方案',
                description: '通过智能系统优化运营，提升环境卫生，强化食安检\n' +
                  '测及长效监管，满足政府、商户、消费者三方需求。',
                picture: require('@/assets/img/solution/pic/so2_4.jpg')
              },
              {
                id: 5,
                title: '平台开发服务',
                description: '提供个性化平台定制服务，从需求分析、功能设计到\n' +
                  '系统开发与优化，为客户量身打造高效、智能的数字\n' +
                  '化解决方案。',
                picture: require('@/assets/img/solution/pic/so2_5.jpg')
              }
            ]
          }
        ],
        logisticsList: [
          {
            list: [
              {
                id: 1,
                title: '营养健康智慧食堂系统',
                description: '以“自选称重/小碗菜自助/订餐核销+营养可视化”模\n' +
                  '式引导按需用餐，实现从取餐到结算的全流程自动\n' +
                  '化管理。',
                picture: require('@/assets/img/solution/pic/so3_1.jpg')
              },
              {
                id: 2,
                title: '健康系统',
                description: `通过AI智能体测仪、中医AI检测仪等设备，构建“测-评-荐-管”一体化的健康服务生态，实现健康追踪与个性化营养改善。`,
                picture: require('@/assets/img/solution/pic/so3_2.jpg')
              },
              {
                id: 3,
                title: '食品安全预警系统',
                description: '依托留样柜、监控大屏、农残检测仪、岗前监控检\n' +
                  '测仪等智能设备，构建多维度食品安全监督预警体\n' +
                  '系，强化源头风险管控。',
                picture: require('@/assets/img/solution/pic/so3_3.jpg')
              }
            ]
          },
          {
            list: [
              {
                id: 4,
                title: '出入库验收系统',
                description: '以智能出入库秤为核心产品，借助先进的AI智能算法，实现从食材称重、识别、记录到溯源的全流程自动化与数据化管理。',
                picture: require('@/assets/img/solution/pic/so3_4.jpg')
              },
              {
                id: 5,
                title: '智慧食堂管理平台',
                description: '通过食堂管理、订餐管理、健康管理、食安管理等模块的协同运作，实现了组织架构管理、设备智能管控、支付系统集成、用户权限分级等核心功能。',
                picture: require('@/assets/img/solution/pic/so3_5.jpg')
              },
              {
                id: 6,
                title: '区县级食品安全预警平台',
                description: '面向区域食品安全治理，依托数据大屏、AI智能分析与全链条溯源能力，构建覆盖主体资质、后厨操作、食材采购等多维度的监管体系。',
                picture: require('@/assets/img/solution/pic/so3_6.jpg')
              }
            ]
          },
          {
            list: [
              {
                id: 7,
                title: '进销存系统',
                description: '涵盖智能报价管理、全流程订单处理、智慧仓储与分拣、全链路质检及业财一体化，全面满足团餐行业对供应链数字化、精细化管理的需求。',
                picture: require('@/assets/img/solution/pic/so3_7.jpg')
              }
            ]
          }
        ],
        wholeList: [
          {
            list: [
              {
                id: 1,
                title: '农产品食品检测服务',
                description: '与多家权威检测机构达成深度战略，具备国际公信力报告资质，覆盖农残、兽药残留、重金属、微生物、食品添加剂等全方位检测项目。',
                picture: require('@/assets/img/solution/pic/so4_1.jpg')
              },
              {
                id: 2,
                title: '快检实验室设计与建设',
                description: '为农产品企业、学校食堂、生鲜配送中心、餐饮连锁等客户量身定制快检实验室，助力客户提升自检效率。',
                picture: require('@/assets/img/solution/pic/so4_2.jpg')
              },
              {
                id: 3,
                title: '快速检测设备与耗材供应',
                description: '提供各类食品安全快检仪器及配套检测试剂、耗材，保障检测工作的便捷性与准确性。',
                picture: require('@/assets/img/solution/pic/so4_3.jpg')
              }
            ]
          },
          {
            list: [
              {
                id: 4,
                title: '食品安全质量体系构建',
                description: '帮助企业建立符合国家标准及行业要求的食品安全管理体系，从制度层面筑牢食品安全防线。',
                picture: require('@/assets/img/solution/pic/so4_4.jpg')
              },
              {
                id: 5,
                title: '食品安全风险诊断',
                description: '通过现场审核、数据分析、隐患排查等手段，帮助企业识别评估生产、加工、流通等环节中的潜在食品安全风险，提出科学可行的改进措施。',
                picture: require('@/assets/img/solution/pic/so4_5.jpg')
              },
              {
                id: 6,
                title: '采后贮运保鲜技术',
                description: '提供冷链物流优化、温湿度控制、气调包装、预冷处理等专业技术支持，延长产品的货架期、减少损耗。',
                picture: require('@/assets/img/solution/pic/so4_6.jpg')
              },
            ]
          },
          {
            list: [
              {
                id: 7,
                title: '鲜切果蔬（净菜）加工技术服务',
                description: '提供净菜加工、鲜切蔬菜保鲜、包装技术、工艺流程优化等解决方案，满足现代餐饮及零售渠道对高品质、便捷化食材的需求。',
                picture: require('@/assets/img/solution/pic/so4_7.jpg')
              }
            ]
          }
        ],
        planList: [
          {
            list: [
              {
                id: 1,
                title: '产业模型',
                description: '由 B2F 共享植物工厂模式、产业生态系统及共享农业各要素组成，形成产业链整合解决方案及 IG-ROWING 精准种植解决方案。',
                picture: require('@/assets/img/solution/pic/so5_1.jpg')
              },
              {
                id: 2,
                title: '财务模型',
                description: '基于智慧农业语境下的收益测算，使产业风险可控、收益可计量、国有资产保值增值。',
                picture: require('@/assets/img/solution/pic/so5_2.jpg')
              },
              {
                id: 3,
                title: '合作模型',
                description: '包括利益分成模式和资产保值模式两种经营托管模式，分别从 “利润共享、风险共担” 和 “资产保全、风险转移” 两个维度，为合作双方提供灵活可选的托管机制。',
                picture: require('@/assets/img/solution/pic/so5_3.jpg')
              }
            ]
          }
        ],
        collegeList: [
          {
            list: [
              {
                id: 1,
                title: '领跑学堂系列课',
                description: '食材产业链盈利倍增实训课、食材产业链利润增长必修课、私董EMBA决策课',
                picture: require('@/assets/img/solution/pic/so6_1.jpg')
              },
              {
                id: 2,
                title: '专项工作坊系列课',
                description: '以“痛点拆解+标杆案例对标+工具输出+研讨共创”为核心，打造“学-练-用”一体化的实战教学体系',
                picture: require('@/assets/img/solution/pic/so6_2.jpg')
              },
              {
                id: 3,
                title: '线上课堂',
                description: '通过“碎片化内容+跨层级共创+移动式工具”三维设计，解决老板、高管“时间紧张、难以集中学习”的痛点',
                picture: require('@/assets/img/solution/pic/so6_3.jpg')
              }
            ]
          }
        ],
      }
    },
    computed: {
      digitalPagedList() {
        return this._slidePages(this.digitalList)
      },
      proPagedList() {
        return this._slidePages(this.proList)
      },
      logisticsPagedList() {
        return this._slidePages(this.logisticsList)
      },
      wholePagedList() {
        return this._slidePages(this.wholeList)
      }
    },
    created () {
      //创建时执行跳转锚点位置
      // this.$nextTick(() => {
      //   this.getLocal();
      // });
      // this.getIndexNewsList()
    },
    mounted () {
    },
    //离开页面进行对localStorage  id销毁，避免其他入口进来有锚点问题
    destroyed() {
      sessionStorage.setItem("slt1", "");
      sessionStorage.setItem("slt2", "");
      sessionStorage.setItem("slt3", "");
      sessionStorage.setItem("slt4", "");
      sessionStorage.setItem("slt5", "");
    },
    methods: {
      // 通用分页方法：每页显示3个，步进3个，最后一页回退填满3个
      _slidePages(list) {
        if (!Array.isArray(list)) return []
        const allItems = list.flatMap(item => item.list)
        const pageSize = 3
        const pages = []
        for (let i = 0; i < allItems.length; i += pageSize) {
          // 剩余不足3个时，回退到末尾往前取3个，确保最后一页填满
          if (allItems.length - i < pageSize) {
            pages.push({ list: allItems.slice(allItems.length - pageSize) })
            break
          }
          pages.push({ list: allItems.slice(i, i + pageSize) })
        }
        return pages
      },
      // 试用
      useClick () {
        this.$refs.applyRef.useClick();
        // this.closeApply()
      },
      getLocal() {
        //找到锚点id
        const selectId1 = sessionStorage.getItem("slt1");
        const selectId2 = sessionStorage.getItem("slt2");
        const selectId3 = sessionStorage.getItem("slt3");
        const selectId4 = sessionStorage.getItem("slt4");
        const selectId5 = sessionStorage.getItem("slt5");
        //如果对应id存在，就跳转
        if (selectId1) {
          document.getElementById(selectId1).scrollIntoView(true)
        }
        if (selectId2) {
          document.getElementById(selectId2).scrollIntoView(true)
        }
        if (selectId3) {
          document.getElementById(selectId3).scrollIntoView(true)
        }
        if (selectId4) {
          document.getElementById(selectId4).scrollIntoView(true)
        }
        if (selectId5) {
          document.getElementById(selectId5).scrollIntoView(true)
        }
      }
    }
  }
</script>
<style lang="scss">
@import '@/styles/pc/common/index.scss';
</style>
<style lang="scss" scoped>
@import "@/styles/pc/carousel/index.scss";
@import '@/styles/pc/solution/index.scss';
</style>
<!--  <script>-->
<!--    let pUrl = window.location.href;-->
<!--    window._bd_share_config = { "common": { "bdSnsKey": {}, "bdText": "", "bdMini": "", "bdMiniList": false, "bdUrl": pUrl, "bdPic": "", "bdStyle": "", "bdSize": "" }, "share": {} };-->
<!--    with (document) 0[(getElementsByTagName('head')[0] || body).appendChild(createElement('script')).src = 'http://bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion=' + ~(-new Date() / 36e5)];-->
<!--  </script>-->

<!--  <script src="js/data.js"></script>-->
<!--  <script>-->
<!--    let availWidth = document.documentElement.clientWidth-->
<!--    if (availWidth < 1023) {-->
<!--      this.changeUrl()-->
<!--    }-->
<!--    window.addEventListener("resize", function() {-->
<!--      let cwAPP = document.documentElement.clientWidth-->
<!--        if ( cwAPP < 1023) {-->
<!--          this.changeUrl()-->
<!--        }-->
<!--    })-->
<!--    function changeUrl() {-->
<!--      let url = 'appsolution.html'-->
<!--      let a = document.createElement('a');-->
<!--      a.setAttribute('href', url);-->
<!--      a.setAttribute('target', '_self');-->
<!--      a.click();-->
<!--    }-->
<!--  </script>-->



// WEBPACK FOOTER //
// src/views/pc/solution.vue